<template>
  <div class="training-modal t-lk-modal__content">
    <h2 v-if="props.title" class="t-lk-modal__title">{{ props.title }}</h2>
    <h2 v-else class="t-lk-modal__title">{{ $root.staticText.lk.requestTitle }}</h2>

    <CoreForm
      class="training-modal__form"
      action="lk/request"
      :form-config="form"
      :submit-label="props.button"
      @submit:success="onSuccessSubmit"
      @submit:error="onErrorSubmit"
    ></CoreForm>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CoreForm from '@shared/ui/public/forms/CoreForm.vue'
import { FORM_COLOR_IDX, LEGACY_FORM_VARIANTS } from '@shared/const/form/form.data'

export default {
  name: 'request',
  props: ['props'],
  components: {
    CoreForm,
  },
  created() {
    this.form.fields.forEach(item => {
      switch (item.content.id) {
        case 'name':
          item.content.value =
            this.profile && (this.profile.name || this.profile.surname) ? this.profile.name + ' ' + this.profile.surname : null
          break
        case 'company':
          item.content.value = this.profile && this.profile.company ? this.profile.company : null
          break
        case 'email':
          item.content.value = this.profile && this.profile.email ? this.profile.email : null
          break
        case 'phone':
          item.content.value = this.profile && this.profile.phone ? this.profile.phone : null
          break
        case 'city':
          item.content.value = this.profile && this.profile.city ? this.profile.city : null
          break
        case 'vendor':
          item.content.value = [
            {
              id: this.props.vendorId,
              label: this.props.vendor,
            },
          ]
          break
      }
    })
  },
  computed: {
    ...mapGetters('lk', ['profile']),
  },
  data() {
    return {
      form: {
        type: LEGACY_FORM_VARIANTS.DEFAULT_BUILDER,
        color: FORM_COLOR_IDX.WHITE,
        fields: [
          {
            type: 'form_field',
            content: {
              id: 'name',
              title: this.$root.staticText.forms.fullName,
              typeField: 1,
              requiredField: 1,
              description: null,
              disabled: true,
              hintField: this.$root.staticText.forms.placeholderFullName,
            },
          },
          {
            type: 'form_field',
            content: {
              id: 'company',
              title: this.$root.staticText.forms.company3,
              typeField: 1,
              requiredField: 1,
              description: null,
              disabled: true,
              hintField: this.$root.staticText.forms.placeholderCompany,
            },
          },
          {
            type: 'form_field',
            content: {
              id: 'city',
              title: this.$root.staticText.forms.city,
              typeField: 1,
              requiredField: 1,
              description: null,
              disabled: true,
              hintField: this.$root.staticText.forms.placeholderCity,
            },
          },
          {
            type: 'form_field',
            content: {
              id: 'email',
              title: this.$root.staticText.forms.email,
              typeField: 4,
              requiredField: 1,
              description: null,
              hintField: this.$root.staticText.forms.placeholderEmail,
            },
          },
          {
            type: 'form_field',
            content: {
              id: 'phone',
              title: this.$root.staticText.forms.phone,
              typeField: 11,
              requiredField: 1,
              description: null,
              hintField: null,
            },
          },
          {
            type: 'form_field',
            content: {
              id: 'vendor',
              title: this.$root.staticText.lk.compTrainingVendor,
              typeField: 8,
              requiredField: 1,
              description: null,
              disabled: true,
              hintField: this.$root.staticText.forms.placeholderTypeRequest2,
              list: this.props.options,
            },
          },
          {
            type: 'form_field',
            content: {
              id: 'comment',
              title: this.$root.staticText.forms.comment2,
              typeField: 2,
              width: 12,
              requiredField: 0,
              description: null,
              hintField: null,
            },
          },
        ],
      },
    }
  },
  methods: {
    ...mapActions('modal', ['modalType_successOpen', 'modalType_errorOpen', 'modalClose']),

    onSuccessSubmit() {
      this.modalClose()

      this.modalType_successOpen({
        title: this.$root.staticText.modal.successTitleFeedback,
        text: this.$root.staticText.modal.successTextFeedback,
        class: '_small',
      })
    },
    onErrorSubmit() {
      this.modalClose()

      this.modalType_errorOpen({
        title: this.$root.staticText.modal.errorTitle,
        text: this.$root.staticText.modal.errorText,
        class: '_small',
      })
    },
  },
}
</script>

<style lang="sass">
@import "~@src/legacy/sass/params"
.training-modal
  &__form
    margin-top: 32px
    @media (max-width: $mobile-size)
      margin-top: 24px
</style>



// WEBPACK FOOTER //
// src/templates/components/base/modals/training.vue